export { default, photoWithCaptionFragment } from "./PhotoWithCaption";



// WEBPACK FOOTER //
// ./src/components/PhotoWithCaption/index.js